import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../../store'
import {
  MarketNewsArticle,
  MarketNewsArticlesApiResponse
} from '../components/articles/api/types/MarketNewsArticles.type'

interface INewsSliceState {
  newsArticles: MarketNewsArticle[]
  nextPageKey: string
  searchTexts: string[]
}

const initialState: INewsSliceState = {
  newsArticles: [],
  nextPageKey: '',
  searchTexts: []
}

const Slice = createSlice({
  name: '@module/markets/news',
  initialState,
  reducers: {
    SetNewsArticles: (state, action: PayloadAction<MarketNewsArticlesApiResponse>) => {
      return {
        ...state,
        newsArticles: [...state.newsArticles, ...(action.payload.response?.data ?? [])],
        nextPageKey: action.payload.response?.meta?.pagination?.next ?? ''
      }
    },
    ClearNewsArticles: (state) => {
      return {
        ...state,
        newsArticles: [],
        nextPageKey: ''
      }
    },
    SetSearchTexts: (state, action: PayloadAction<string[]>) => {
      return {
        ...state,
        searchTexts: action.payload
      }
    }
  }
})

export const { SetNewsArticles, ClearNewsArticles, SetSearchTexts } = Slice.actions
export const getNewsArticles = (state: RootState) => state.modules.markets.news.newsArticles
export const getNewsNextPageKey = (state: RootState) => state.modules.markets.news.nextPageKey
export const getNewsSearchTexts = (state: RootState) => state.modules.markets.news.searchTexts
export default Slice.reducer
